import { Map } from 'lucide-react';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  ToolHeaderRow,
  ToolTitleGroup,
  ToolTitleText,
  MapToggleButton,
} from '../../styles';

interface TracertHeaderProps {
  isDone: boolean;
  traceStarted: boolean;
  mapped: boolean;
  mapping: boolean;
  isComplete: boolean;
  onToggleMap: () => void;
}

// Displays the header for the traceroute tool
export function TracertHeader({
  isDone,
  traceStarted,
  mapped,
  mapping,
  isComplete,
  onToggleMap,
}: TracertHeaderProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ToolHeaderRow>
      <ToolTitleGroup>
        <Map color={theme.palette.white['06']} size={22} />
        <ToolTitleText variant="h3">
          {t('tools.traceroute.title')}
        </ToolTitleText>
      </ToolTitleGroup>
      {(isDone || traceStarted) && (
        <MapToggleButton
          variant="text"
          startIcon={
            mapping ? <CircularProgress size="14px" /> : <Map size="14px" />
          }
          onClick={onToggleMap}
          disabled={traceStarted || mapping || !isComplete}
        >
          {mapped
            ? t('tools.traceroute.hideMap')
            : t('tools.traceroute.showMap')}
        </MapToggleButton>
      )}
    </ToolHeaderRow>
  );
}

export default TracertHeader;
